module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/rv3.webp";